import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  mailIconButton: {
    color: '#DF0C36',
    margin: '30px 30px',
  },
  title: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '28px',
    lineHeight: '36px',
    letterSpacing: 0,
    color: '#666666',
    margin: '15px',
    padding: 0,
  },
  validateButton: {
    width: 110,
    height: 34,
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    backgroundColor: '#DF0C36',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#B00429',
    },
  },
  changeButton: {
    width: 110,
    height: 34,
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    color: '#DF0C36',
    borderColor: '#DF0C36',
    borderRadius: 0,
    marginRight: '24px',
    '&:hover': {
      color: '#B00429',
      borderColor: '#B00429',
      backgroundColor: '#FFFFFF',
    },
  },
  dialogContent: {
    marginLeft: '15px',
    marginRight: '80px',
  },
  dialogText: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#333333',
    textAlign: 'justify',
  },
  dialogActions: {
    marginRight: '80px',
    marginBottom: '40px',
  },
  paper: {
    width: '780px',
  },
}));
